import { Hero } from '@/components/Hero'
import { Highlights } from '@/components/Highlights'
import { ProjectCard } from '@/components/ProjectCard'
import { Skills } from '@/components/Skills'
import { Contact } from '@/components/Contact'
import { useContent } from '@/lib/content-context'
import { Link } from 'react-router-dom'
import { Button } from '@/ui'
import { useTranslation } from '@/i18n'

export function Home() {
  const { projects } = useContent()
  const { t } = useTranslation()

  // Show first 4 projects on home
  const displayProjects = projects.slice(0, 4)

  return (
    <div>
      <Hero />
      <Highlights />

      {/* Featured Projects Section */}
      <section className="py-12 px-4 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-3xl font-bold dark:text-gray-100">{t('home.featuredProjects')}</h2>
            <Link to="/projects">
              <Button variant="outline" size="sm">
                {t('projects.viewAll')}
              </Button>
            </Link>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {displayProjects.map((project) => (
              <Link key={project.id} to={`/projects/${project.id}`}>
                <ProjectCard project={project} />
              </Link>
            ))}
          </div>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-4">
        <Skills />
      </div>

      {/* AI-Assisted Engineering Section */}
      <section id="ai-tools" className="py-12 px-4 bg-white dark:bg-gray-900">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold mb-6 dark:text-gray-100">{t('home.aiTitle')}</h2>
          <div className="bg-gradient-to-r from-purple-50 to-blue-50 dark:from-purple-950/20 dark:to-blue-950/20 border border-purple-200 dark:border-purple-800 rounded-lg p-8">
            <div className="flex items-start gap-4 mb-6">
              <span className="text-4xl">🤖</span>
              <div className="flex-1">
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                  {t('home.aiDescription')}
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-4">
              <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-purple-100 dark:border-purple-900">
                <h4 className="font-semibold mb-2 dark:text-gray-100">{t('home.privacyTitle')}</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">{t('home.privacyDesc')}</p>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-purple-100 dark:border-purple-900">
                <h4 className="font-semibold mb-2 dark:text-gray-100">{t('home.devopsTitle')}</h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">{t('home.devopsDesc')}</p>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border border-purple-100 dark:border-purple-900">
                <h4 className="font-semibold mb-2 dark:text-gray-100">
                  {t('home.selectiveTitle')}
                </h4>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {t('home.selectiveDesc')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Contact />
    </div>
  )
}
